import { useState } from "react";
import { Link } from "react-scroll";
import { motion, AnimatePresence } from "framer-motion";

const sections = [
  { id: "home", label: "Overview" },
  { id: "testimonials", label: "Recommendations" },
  { id: "about", label: "About" },
  { id: "resume", label: "Experience" },
  { id: "skills", label: "Skills" },
  { id: "articles", label: "Writing" },
  { id: "projects", label: "Projects" },
  { id: "footer", label: "Contact & links" },
];

function Navbar() {
  const [isOpen, setIsOpen] = useState(false);
  const closeMenu = () => setIsOpen(false);

  const sectionLinks = (mobile = false) => sections.map(({ id, label }, index) => (
    <Link
      key={id}
      to={id}
      smooth
      duration={500}
      spy
      activeClass="active-nav"
      onClick={mobile ? closeMenu : undefined}
      className={`portfolio-nav-link ${mobile ? "mobile-nav-link" : ""}`}
    >
      <span className="nav-index">{String(index + 1).padStart(2, "0")}</span>
      <span>{label}</span>
    </Link>
  ));

  return (
    <>
      <nav className="portfolio-rail" aria-label="Main navigation">
        <a href="/#home" className="rail-brand">
          <img src="/resources/images/logo.png" alt="" />
          <span>
            <strong>Tuhin Dutta</strong>
            <small>PORTFOLIO</small>
          </span>
        </a>

        <div className="rail-caption">INDEX</div>
        <div className="rail-links">{sectionLinks()}</div>

        <div className="rail-bottom">
          <span className="rail-status"><i /> Data · AI · Engineering</span>
          <span className="rail-signature">Transforming Data Into Impact</span>
        </div>
      </nav>

      <header className="mobile-portfolio-header">
        <a href="/#home" className="mobile-brand">
          <img src="/resources/images/logo.png" alt="" />
          <span>Tuhin Dutta <small>Portfolio</small></span>
        </a>
        <button
          type="button"
          onClick={() => setIsOpen(!isOpen)}
          aria-label={isOpen ? "Close navigation" : "Open navigation"}
          aria-expanded={isOpen}
          className="mobile-nav-toggle"
        >
          {isOpen ? "×" : "☰"}
        </button>
      </header>

      <AnimatePresence>
        {isOpen && (
          <motion.div
            className="mobile-nav-backdrop"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            onClick={closeMenu}
          >
            <motion.nav
              className="mobile-nav-panel"
              aria-label="Main navigation"
              initial={{ x: "100%" }}
              animate={{ x: 0 }}
              exit={{ x: "100%" }}
              transition={{ duration: 0.22, ease: "easeOut" }}
              onClick={(event) => event.stopPropagation()}
            >
              <div className="rail-caption">JUMP TO SECTION</div>
              {sectionLinks(true)}
            </motion.nav>
          </motion.div>
        )}
      </AnimatePresence>
    </>
  );
}

export default Navbar;
